/*
 * @Author: Zheng Lei
 * @Email: baimoc@163.com
 * @Date: 2020-06-14 09:47:03
 * @LastEditTime: 2023-02-28 13:38:35
 * @FilePath: \raacfold\src\main.js
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from "./store";
// import All from "./module/moduleA" // 导入所有方法
// import {B1,B2} from "./module/moduleB" // 可选择导入特定的方法
// import {B1 as mB} from "./module/moduleB" // 给导入方法别名

// 引入 element UI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en'


// 引入mint-ui
// import MintUI from "mint-ui"
// import 'mint-ui/lib/style.css'

// 引入JQuery
// import $ from 'jquery'

// BootstrapVue
// import "bootstrap"
import "jquery"
// import 'bootstrap/dist/js/bootstrap'
import 'bootstrap/dist/css/bootstrap.css'
import './assets/iconfont/baimofont/iconfont.css'
// import '../assets/css/baimoc.css'

import {
    HappyScroll
} from 'vue-happy-scroll'
//自定义组件名
Vue.component('happy-scroll', HappyScroll);
// 引入css
import 'vue-happy-scroll/docs/happy-scroll.css'
// 设置语言
Vue.use(ElementUI, {
    locale
})
// Vue.use(ElementUI, { locale });
// Vue.use(MintUI)

// console.log(All)
// console.log(B1,B2)
// console.log(mB)

Vue.config.productionTip = false;

new Vue({
    router: router,
    store: store,
    render: h => h(App),
}).$mount('#app')

setTimeout(console.clear.bind(console, ""));
let year = new Date().getFullYear();
let copyright = `©${year} By Zhenglei`
let email = "✉️ baimoc@163.com"
let website = "🏠 https://www.ziptop.top"
let license = `${copyright} | Please comply with the GPL License.`
let contact = `Developer ${email}  ${website}`
setTimeout(console.log.bind(console, `${contact}\n\n${license}`));